import PolarityOptions from "./PolarityOptions";
const Level = () => {
    return <PolarityOptions />;
};

export default Level;
